var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricityTertiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.948C11.988 15.128 8.08798 11.492 4.58398 7.508C8.89198 10.616 12.744 14.204 16.5 17.948Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7642 14.84C18.0602 12.944 16.8602 10.748 16.2002 8.28799C17.9162 10.184 19.1042 12.38 19.7642 14.84Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6079 32.756C36.0839 35.624 39.9599 39.296 43.4279 43.316C39.1439 40.172 35.3399 36.536 31.6079 32.756Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3081 35.828C30.0001 37.736 31.1761 39.956 31.8121 42.416C30.1201 40.496 28.9561 38.3 28.3081 35.828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1398 4.28001C37.1998 4.17201 37.0558 4.06401 36.9598 4.14801L18.8518 22.304H18.8278L14.4238 26.756H22.4638L12.5278 44.72C12.4678 44.828 12.6118 44.936 12.7078 44.852L30.7558 26.756H30.7678L35.1718 22.304H27.1558L37.1398 4.28001Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 0.44,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6879 17.168L18.5879 25.292H26.3759L22.7639 31.808C22.7639 31.808 22.7639 31.832 22.7759 31.808L30.8519 23.708H23.0759L26.6999 17.168C26.6999 17.168 26.6999 17.144 26.6879 17.168Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 0.32,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityTertiary);
export default __webpack_public_path__ + "static/media/electricity-tertiary.e6a75e7aea7c77f16dc32cf8c8958c65.svg";
export { ForwardRef as ReactComponent };